var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.cssClasses},[_c('VasionDocumentTemplateIconLarge'),_c('div',{staticClass:"form-submitted"},[_vm._v(" Form Submitted ")]),_c('div',{staticClass:"thank-you"},[_vm._v(" Thank you for using Vasion ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }